window.$ = window.jQuery = require('jquery');
window.toastr = require('toastr');
require('bootstrap');
require('slick-carousel');
require('lightbox2');
require('bootstrap-datepicker');

$('[data-datepicker]').datepicker({
    format: 'yyyy-mm-dd'
});

require('jquery-validation');
$.validator.setDefaults({
    highlight: function (element) {
        $(element).closest('.form-group').addClass('has-error');
    },
    unhighlight: function (element) {
        $(element).closest('.form-group').removeClass('has-error');
    },
    errorElement: 'span',
    errorClass: 'help-block',
    errorPlacement: function (error, element) {
        if (element.parent('.input-group').length) {
            error.insertAfter(element.parent());
        } else {
            error.insertAfter(element);
        }
    }
});
$('[data-validated]').validate();

let $html = $('html');

function isRTL() {
    return $html.attr('lang') === 'ar';
}

$('#slider').slick({
    arrows: true,
    rtl: isRTL(),
    autoplay: true
});

$('#gallery').find('.slider').slick({
    arrows: false,
    rtl: isRTL(),
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true
});

$('#partners').find('.slider').slick({
    rtl: isRTL(),
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true
});

$('#latest-news').find('[data-target]').on('click', function (e) {
    e.preventDefault();

    $('#latest-news').find('[data-target]').removeClass('active');
    $(this).addClass('active');

    $('[data-news-item-id]').removeClass('active');
    $('[data-news-item-id=' + $(this).data('target') + ']').addClass('active');
});

let $newsItem = $('#news-item');
$newsItem.find('.slider').slick({
    rtl: isRTL(),
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '#news-item .slider-nav'
});

$newsItem.find('.slider-nav').slick({
    rtl: isRTL(),
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '#news-item .slider',
    centerMode: true,
    focusOnSelect: true
});


// WEBPACK FOOTER //
// ./resources/assets/front/js/app.js